module.exports = __webpack_public_path__ + "static/media/delete-wall.aa0a94e3.gif";